import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircleHeart, ArrowRight } from "lucide-react";
import Layout from "@/components/Layout";
import Hero from "@/components/Hero";
import CenturyIntro from "@/components/CenturyIntro";
import Timeline from "@/components/Timeline";
import RoyalRecognition from "@/components/RoyalRecognition";
import PhotoGallery from "@/components/PhotoGallery";
import VideoGallery from "@/components/VideoGallery";
import DonateCTA from "@/components/DonateCTA";
import RaritySection from "@/components/RaritySection";
import { SCENES } from "@/lib/images";

function FanWallInvite() {
  return (
    <section className="relative overflow-hidden bg-sand py-24 md:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-4xl block mb-2">🎂</span>
          <h2 className="mt-2 font-serif text-4xl font-bold tracking-tight text-forest md:text-5xl">
            Don't forget to sign<br /><span className="italic text-terracotta">the birthday card</span>
          </h2>
          <p className="mt-5 max-w-md leading-relaxed text-forest/75 md:text-lg">
            Agnes turns 107 on August 22nd. Add your name and a birthday wish — your signature
            joins everyone else's on her special card and stays there forever. 💛
          </p>
          <Link
            to="/fan-wall"
            data-testid="home-fanwall-cta"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 font-medium text-cream transition hover:bg-terracotta-dark"
          >
            Sign the card
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7 }}
          className="relative grid grid-cols-2 gap-4"
        >
          {[
            { n: "Mary", t: "Happy birthday, dear Agnes! ❤️", r: "-rotate-3" },
            { n: "Tom", t: "A true legend. 🎉", r: "rotate-2 mt-8" },
            { n: "Síofra", t: "Sending love from Galway 🌹", r: "rotate-1" },
            { n: "James", t: "107 and shining! 👑", r: "-rotate-2 -mt-4" },
          ].map((c) => (
            <div key={c.n} className={`rounded-xl bg-cream p-5 paper-note ${c.r}`}>
              <p className="font-hand text-2xl text-terracotta">{c.n}</p>
              <p className="font-hand text-lg text-forest/85">{c.t}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <Layout>
      <Hero />
      <CenturyIntro />
      <DonateCTA />
      <RaritySection />
      <Timeline />
      <RoyalRecognition />
      <PhotoGallery />
      <VideoGallery />
      <FanWallInvite />
    </Layout>
  );
}
